import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-round",
  "use": "icon-close-round-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close-round\"><path d=\"M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0zm0 998.4C243.2 998.4 25.6 780.8 25.6 512S243.2 25.6 512 25.6 998.4 243.2 998.4 512 780.8 998.4 512 998.4z\" /><path d=\"M706.56 296.96L512 494.08 317.44 296.96l-20.48 20.48L494.08 512 296.96 706.56l20.48 20.48L512 529.92l194.56 197.12 20.48-20.48L529.92 512l197.12-194.56z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol